import type { VocabCard } from './vocab-types.ts';

let cache: VocabCard[] | null = null;

export async function loadVocabDeck(): Promise<VocabCard[]> {
  if (cache) return cache;
  const res = await fetch('/data/vocab-deck.json');
  if (!res.ok) throw new Error(`Failed to load vocab deck: ${res.status}`);
  cache = await res.json() as VocabCard[];
  return cache;
}

export function getCardsForLevel(deck: VocabCard[], cefr: string): VocabCard[] {
  return deck.filter(c => c.cefr === cefr);
}

export function getCardsUpToLevel(deck: VocabCard[], cefr: string): VocabCard[] {
  const order = ['A1.1', 'A1.2', 'A1.3', 'A1.4', 'A2.1', 'A2.2', 'A2.3', 'A2.4', 'B1.1', 'B1.2', 'B1.3', 'B1.4'];
  const idx = order.indexOf(cefr);
  if (idx < 0) return deck;
  const allowed = new Set(order.slice(0, idx + 1));
  return deck.filter(c => allowed.has(c.cefr));
}
